module.exports = __webpack_public_path__ + "static/media/SDF.98bf2769.jpg";